/**
 * Basic module class definition providing basic interface functions
 */
class BaseModule {

	/**
	 * Initialize a module with a config provided by the AppConmoduleConfig
	 * @param {moduleConfig} moduleConfig - Config parsed from teh DOM
	 */
	constructor ( moduleConfig ) {

		/**
		 *
		 * @type {Object}
		 */
		this.node       = moduleConfig.node;
		/**
		 *
		 * @type {Object}
		 */
		this.config     = moduleConfig.config;
		/**
		 *
		 * @type {string}
		 */
		this.identifier = moduleConfig.identifier;
	}

	init () {
		return this;
	}

	/**
	 * @return {string} returns the identifier for the module instance
	 */
	getIdentifier () {
		return this.identifier;
	}
}

export default BaseModule;



// WEBPACK FOOTER //
// ./js/modules/Base.module.js